export const LOCALES = {
  POLISH: 'pl-PL',
  GERMAN: 'de-DE',
};
